// app/frontend/controllers/leads/companies/highlight_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const highlightCompanyIds = urlParams.get("highlight_company_ids")

    if (highlightCompanyIds) {
      const idsToHighlight = highlightCompanyIds.split(",")
      this.highlightRows(idsToHighlight)

      this.removeHighlightParamFromUrl()
    }
  }

  highlightRows(idsToHighlight) {
    const rows = this.element.querySelectorAll("tbody tr")

    rows.forEach((row) => {
      const cellWithId = row.querySelector("td[data-record-id]")

      if (cellWithId) {
        const recordId = cellWithId.getAttribute("data-record-id")

        if (idsToHighlight.includes(recordId)) {
          row.classList.add("highlighted")

          setTimeout(() => {
            row.classList.add("fading-out")

            setTimeout(() => {
              row.classList.remove("highlighted")
              row.classList.remove("fading-out")
            }, 500) // This should match the transition duration in CSS
          }, 4500)
        }
      }
    })
  }

  removeHighlightParamFromUrl() {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    params.delete("highlight_company_ids")

    const newUrl = !params.toString() ? url.pathname : `${url.pathname}?${params.toString()}`

    window.history.replaceState({}, "", newUrl)
  }
}
